export enum CompanyPermissions {
  ACCESS_ANY = 'company.view-any',
  EDIT_METADATA = 'company.edit',
  MERGE = 'company.merge',
  LINK_MANAGER = 'company.manage-links',
  LINK_UNLINK_ANY_DATE = 'company.link_unlink.any_date',
}

export enum InvoicePermissions {
  EDIT_INVOICE = 'invoice.edit',
  ACCESS_REPORT = 'invoice.report',
  ANY_CLIENT_INVOICES = 'invoice.view-client-invoices',
  ANY_SUPPLIER_INVOICES = 'invoice.view-supplier-invoices',
  EDIT_REPORT = 'invoice.edit-report',
  OPEN_CLOSE_INVOICE = 'invoice.open-close-invoice',
  ADVANCE_INVOICE = 'invoice.advance-invoice',
}

export enum UserPermissions {
  EDIT_DATA = 'user.edit-data',
  CHANGE_PASSWORD = 'user.change-password',
  EDIT_ROLES = 'user.edit-roles',
  EDIT_REMOTE_ACCESS = 'user.edit-remote-access',
}

export enum AccountingPermissions {
  ACCOUNTING_ACCESS = 'accounting.access',
  CURRENT_ACCOUNTS = 'accounting.current-accounts',
  VIEW_PERSONS = 'accounting.view-persons',
}

export enum AuditPermissions {
  VIEW = 'audit.view',
}

export enum MediaPermissions {
  EDIT = 'media.edit',
}

export enum SupplierPermissions {
  EDIT = 'suppliers.edit',
}

export enum GeoPermissions {
  ANY = 'geo.any',
}
export enum SalesDepartmentsPermissions {
  EDIT = 'sales_departments.edit',
}
export enum TimeSheetPermissions {
  EDIT = 'timesheet.edit',
}
export enum EventPermissions {
  VIEW_ANY = 'event.view-any',
}

export enum TaskPermissions {
  ANY = 'task.any',
}

export enum SettingsPermissions {
  ANY = 'settings.any',
  FILES = 'settings.files',
}

export enum PurchasesPermissions {
  ALL_STATUSES = 'purchases.all_statuses',
  CUSTOM_STATUSES = 'purchases.custom_statuses',
  MASS_EDIT_STATUSES = 'purchases.mass_edit_statuses',
}

export enum PricePermissions {
  EDIT = 'price.edit',
}

export enum LegalEntityPermissions {
  EDIT = 'legal-entity.edit',
}

export enum LeadPermissions {
  CHANGE_QUALITY = 'lead.change-quality',
  ADMIN = 'lead.admin',
  ACCESS_STATUS_NEW = 'lead.view.new',
  ACCESS_STATUS_UNKNOWN = 'lead.view.unknown',
  CHANGE_STATUS = 'lead.change-status',
  CHANGE_STATUS_TO_CLOSED = 'lead.change-status.closed',
  CHANGE_STATUS_TO_PRICE_OR_PRICE_PROCESSED = 'lead.change-status.price-or-price-processed',
  CHANGE_STATUS_TO_SPAM_OR_UNKNOWN_OR_UNKNOWN_PROCESSED = 'lead.change-status.spam-or-unknown-or-unknown-processed',
}
export enum SalaryPermissions {
  EDIT_STATEMENT = 'salary.statement',
  RESERVE_FUND = 'salary.reserve-fund',
  PERCENTAGE_SUPERVISOR = 'salary.percentage-supervisor',
  SALARY_USERS = 'salary.salary-users',
  CLOSE_WORK_SHIFT_ANY = 'salary.work-shift.close-any',
  PRINT_STATEMENT = 'salary.statement-print',
}

export enum ReportPermissions {
  VIEW_ACCOUNT_BALANCE = 'report.view-account-balance',
  VIEW_CASHFLOW = 'report.view-cashflow',
  VIEW_SALES = 'report.view-sales',
  VIEW_CALLS = 'report.view-calls',
  VIEW_TOP_MANAGER = 'report.view-top-manager',
}

export enum WccPermissions {
  BULK_CREATE_AND_EXPORT = 'wcc.bulk-create-export',
  VIEW_ANY = 'wcc.view-any',
  CREATE_EDIT = 'wcc.create-edit',
}


export enum TagsPermissions {
  EDIT = 'tag.edit-tags',
  COMPANY = 'tag.company',
}

// for future permissions implementations, eg. invoice permissions etc...
enum OtherPermissions {}

export type PermissionScope =
  | CompanyPermissions
  | InvoicePermissions
  | UserPermissions
  | AccountingPermissions
  | AuditPermissions
  | MediaPermissions
  | SupplierPermissions
  | GeoPermissions
  | SalesDepartmentsPermissions
  | EventPermissions
  | TimeSheetPermissions
  | SettingsPermissions
  | PurchasesPermissions
  | PricePermissions
  | LegalEntityPermissions
  | ReportPermissions
  | SalaryPermissions
  | LeadPermissions
  | WccPermissions
  | TagsPermissions
  | TaskPermissions
  | OtherPermissions;

export type AuthorizedUser = {
  id: number;
  firstName: string;
  secondName: string;
  middleName: string;
  permissions: PermissionScope[];
  createdAtPassword: Date;
  isAdmin: boolean;
};

export type LoginDto = {
  login: string;
  password: string;
};

export type RefreshTokenDto = {
  refreshToken: string;
};

export type LoginResponseDto = {
  authorizedUser: AuthorizedUser;
  accessToken: string;
  refreshToken: string;
};
